import React, { useCallback, createRef } from 'react';
import { MailIcon } from 'components/style-guide/icons';
import PhoneInput from 'components/style-guide/form/phone-input/PhoneInput';
import FormikInput from 'components/style-guide/form/formik-input/FormikInput';
import clsx from 'clsx';
import { Field } from 'formik';
import { Checkbox, GoogleRecaptcha } from 'components';
import { formatRut } from 'shared/utils';

import styles from './PersonalForm.module.scss';


export const PersonalForm = ({ values, setValues, handleBlur, setFieldValue, userInfo, setFieldTouched }) => {

    const columnStyle = 'col-sm-6 col-md-4';
    const recaptchaRef = createRef();
    const handleProfileToggle = useCallback(v => {
        const { name, phone, rut, email, fatherLastName, motherLastName } = userInfo || {};

        let fullName = '';


        if (name) fullName += name;
        if (fatherLastName) fullName += ' ' + fatherLastName;
        if (motherLastName) fullName += ' ' + motherLastName;


        if (v.target.checked) {
            setValues({
                ...values,
                name: fullName,
                phone,
                rut: formatRut(rut),
                email,
            });
        }
    }, [values, userInfo]);

    const handlePhoneChange = useCallback((v, phoneDetails) => {
        setFieldValue('phone', v, phoneDetails.countryCode);
        setFieldValue('countryCode', phoneDetails.countryCode.toUpperCase());
    }, []);

    return (
        <div>
            <span>
                <div className="mb-4 mt-2">
                    <span className="form-title mr-4">Datos Personales</span>
                    {
                        userInfo &&
                        (
                            <span className={styles.pickProfileData}>
                                <Checkbox
                                    value={true} id="profileCheck"
                                    onChange={handleProfileToggle}
                                    label="Usar los datos de Mi Perfil" />
                            </span>
                        )
                    }
                </div>
            </span>
            <div className="row">
                <FormikInput
                    wrapperClassName={columnStyle}
                    name="rut"
                    label="RUT"
                    required
                    setFormat={event => {
                        setFieldValue('rut', formatRut(values['rut']));
                        setTimeout(() => setFieldTouched('rut', true, false));
                    }}
                />
                <FormikInput wrapperClassName={columnStyle} name="name" label="Nombre y Apellidos" required />
                <FormikInput
                    wrapperClassName={columnStyle}
                    Component={PhoneInput}
                    country={'cl'}
                    name="phone"
                    label="Teléfono"
                    onChange={handlePhoneChange}
                />

                <FormikInput
                    wrapperClassName={columnStyle}
                    required
                    classNameInputPrefixIcon={styles.mailInput}
                    prefixIcon={(<MailIcon fill="#9FA6B2" />)} prefixTop={39} inputLeft={36}
                    label="Correo Electrónico"
                    name="email"
                />

                {
                    !userInfo &&
                    <FormikInput
                        wrapperClassName={columnStyle}
                        required
                        classNameInputPrefixIcon={styles.mailInput}
                        prefixIcon={(<MailIcon fill="#9FA6B2" />)} prefixTop={39} inputLeft={36}
                        label="Confirmación de Correo Electrónico"
                        name="emailConfirm"
                    />
                }
                {
                    !userInfo &&
                    <div className="col-sm">
                        <Field name="recaptcha">
                            {({ meta }) => (
                                <>
                                    <GoogleRecaptcha ref={recaptchaRef} onChange={(e) => {
                                        setFieldValue('recaptcha', e || '');

                                    }} />
                                    {meta.touched && meta.error &&
                                        <small
                                            className={clsx('form-text is-invalid invalid-feedback d-flex')}>{meta.error}</small>}
                                </>
                            )}
                        </Field>
                    </div>}
            </div>
        </div>
    );
};

PersonalForm.propTypes = {};

export default React.memo(PersonalForm);
